export default "__VITE_ASSET__d0cc8eab__"